import { render, staticRenderFns } from "./SeizureGraph.vue?vue&type=template&id=55d606b2&"
import script from "./SeizureGraph.vue?vue&type=script&lang=js&"
export * from "./SeizureGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports